export default __webpack_public_path__ + "c63548c0baf6ecff6c76a3cb8d1eaa02.png";